module.exports = __webpack_public_path__ + "img/kantenkontakt.85cab44c.png";